var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbox',[_c('b-button',{staticClass:"style-button",attrs:{"variant":"outline-secondary"},on:{"click":function($event){return _vm.openMetadata()}}},[_c('i',{staticClass:"fa fa-info"})]),_c('edition-metadata-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }